import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { VirtualConnectionSortOrder, WorkbookUpstreamVirtualConnectionsQueryVariables, WorkbookUpstreamVirtualConnectionsQuery, VirtualConnectionsDisplayGridRowDataFragment, UpstreamVirtualConnectionsFilteredByFieldQueryVariables, UpstreamVirtualConnectionsFilteredByFieldQuery , UpstreamVirtualConnectionsFilteredByFieldDocument , WorkbookUpstreamVirtualConnectionsDocument } from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, MaxCountsResultData, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import { getRowDataWithMaxCountsForVirtualConnection } from '../database/functions/VirtualConnectionRowDataFunctions';
import { VirtualConnectionsDisplayGridRowData } from '../database/types/VirtualConnectionDisplayGridRowData';
import { VirtualConnectionsDisplayGrid } from '../sharedDisplayGrid/VirtualConnectionsDisplayGrid';
import { VirtualConnectionsValidSortFields } from '../sorting/sortProviders/VirtualConnectionsGridSortProvider';

type QueryVariables = WorkbookUpstreamVirtualConnectionsQueryVariables;
type QueryResults = WorkbookUpstreamVirtualConnectionsQuery;
type QueryResultListNode = VirtualConnectionsDisplayGridRowDataFragment;
type GridRowData = VirtualConnectionsDisplayGridRowData;

type QueryVariablesWithFilter = UpstreamVirtualConnectionsFilteredByFieldQueryVariables;
type QueryResultsWithFilter = UpstreamVirtualConnectionsFilteredByFieldQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.workbooks && resultData.workbooks[0] && resultData.workbooks[0].upstreamVirtualConnectionsConnection;
}

function selectConnectionListResultForFilteredQuery(resultData: QueryResultsWithFilter): ConnectionListResult<QueryResultListNode> | null {
  return (
    resultData &&
    resultData.fieldsConnection &&
    resultData.fieldsConnection.nodes &&
    resultData.fieldsConnection.nodes[0] &&
    resultData.fieldsConnection.nodes[0].upstreamVirtualConnectionsConnection
  );
}

function selectMaxCountsResult(resultData: QueryResults): MaxCountsResultData {
  return resultData && resultData.workbooks && resultData.workbooks[0];
}

function selectMaxCountsResultForFilteredQuery(resultData: QueryResultsWithFilter): MaxCountsResultData {
  return resultData && resultData.fieldsConnection &&
    resultData.fieldsConnection.nodes && resultData.fieldsConnection.nodes[0];
}

function getRowDataForVirtualConnection(
  node: QueryResultListNode,
  resultData: QueryResults,
): GridRowData {
  return getRowDataWithMaxCountsForVirtualConnection(node, selectMaxCountsResult(resultData));
}

function getRowDataForVirtualConnectionForFilteredQuery(
  node: QueryResultListNode,
  resultData: QueryResultsWithFilter,
): GridRowData {
  return getRowDataWithMaxCountsForVirtualConnection(node, selectMaxCountsResultForFilteredQuery(resultData));
}

export type WorkbookUpstreamVirtualConnectionsQueryGridProps = GridSortProps<VirtualConnectionsValidSortFields> & {
  readonly vizportalUrlId: string;
  readonly filteredFieldId: string | null;
  readonly rowCount: number | null;
};

export function WorkbookUpstreamVirtualConnectionsQueryGrid(props: WorkbookUpstreamVirtualConnectionsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyUpstreamVirtualConnectionsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyUpstreamFilteredVirtualConnectionsLineageGridMessage();

  return props.filteredFieldId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={UpstreamVirtualConnectionsFilteredByFieldDocument}
      partialQueryVariables={{ selectedFieldId: props.filteredFieldId, orderBy: props.orderBy as VirtualConnectionSortOrder }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForVirtualConnectionForFilteredQuery}
    >
      {({ rowStore }) => (
        <VirtualConnectionsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={WorkbookUpstreamVirtualConnectionsDocument}
      partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as VirtualConnectionSortOrder }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForVirtualConnection}
    >
      {({ rowStore }) => (
        <VirtualConnectionsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
